import moment from 'moment';
import {
  ICustomerPricing,
  ICustomerPricingData,
  ICustomerPricingFieldError,
  ICustomerPricingFieldErrorData
} from './customerpricing.types';

export class CustomerPricing implements ICustomerPricing {
  id?: number;
  snapshot?: number;
  customer = '';
  validity: string = moment(new Date())
    .add(30, 'd')
    .format('YYYY-MM-DD');

  updated_at?: Date | string;

  constructor(data: ICustomerPricingData) {
    if (data.id) {
      this.id = data.id;
    }
    if (data.snapshot) {
      this.snapshot = data.snapshot;
    }

    if (data.customer) {
      this.customer = data.customer;
    }

    if (data.validity) {
      this.validity = data.validity;
    }

    if (data.updated_at) {
      this.updated_at = data.updated_at;
    }
  }

  isValid(date: string | Date): boolean {
    return moment(this.validity)
      .endOf('day')
      .isAfter(moment(date), 'minute');
  }

  validate(): boolean {
    if (!this.snapshot) {
      return false;
    }
    if (!this.customer) {
      return false;
    }
    if (!this.validity) {
      return false;
    }

    return true;
  }
}

export class CustomerPricingFieldError implements ICustomerPricingFieldError {
  readonly validity: string[] = [];
  readonly snapshot: string[] = [];
  readonly customer: string[] = [];

  constructor(data?: ICustomerPricingFieldErrorData) {
    if (data) {
      if (data.snapshot) {
        this.snapshot = data.snapshot;
      }
      if (data.validity) {
        this.validity = data.validity;
      }
      if (data.customer) {
        this.customer = data.customer;
      }
    }
  }

  clearErrors(): void {
    this.snapshot.splice(0, this.snapshot.length);
    this.validity.splice(0, this.validity.length);
    this.customer.splice(0, this.customer.length);
  }

  static isCustomerPricingFieldError(
    data: ICustomerPricingFieldErrorData
  ): boolean {
    if (data.snapshot && Array.isArray(data.snapshot)) {
      return true;
    }
    if (data.validity && Array.isArray(data.validity)) {
      return true;
    }
    if (data.customer && Array.isArray(data.customer)) {
      return true;
    }

    return false;
  }
}
